import { Card } from '@/components';
import { FC } from 'react';
import TrendingYieldBearingAssetsCardBody from './TrendingYieldBearingAssetsCardBody';
import TrendingYieldBearingAssetsCardHeader from './TrendingYieldBearingAssetsCardHeader';
interface Props {
  className?: string;
}
const TrendingYieldBearingAssetsCard: FC<Props> = ({ className }) => {
  return (
    <Card className={`${className}`}>
      <TrendingYieldBearingAssetsCardHeader />
      <TrendingYieldBearingAssetsCardBody />
    </Card>
  );
};
export default TrendingYieldBearingAssetsCard;
